import React from 'react';
import '../App.css';
import $ from 'jquery';
import config from '.././config.json';
import {
    Form, Select,
    Button, Spin, notification
} from 'antd';

import { Redirect } from 'react-router';
import LoginForm from '../LoginForm.js';

const FormItem = Form.Item;
const Option = Select.Option;

class UpdateEnrollmentModalForm extends React.Component {

    formVariables = [ { selectUpdateAttendance: '' } ];

    constructor(props) {
        super(props);

        this.state = {
            classData: [],
            loading: false,
            login: true,
            selectUpdateAttendance: ''
        };

    }

    componentDidMount() {
        LoginForm.ValidateServerToken(
            () => { this.setState({ login: false }) }, //logout
            () => {
                // Should I remove this setting right here?
                if( this.props.updateFields !== undefined) {
                    this.formVariables.selectUpdateAttendance = this.props.updateFields.AttendanceSelection;
                }
                

                // get the data pertaining to one class (will need class mode id)
                this.ajaxCall('GET', '/api/classes/getid/' + this.props.updatingClassId,
                    {}, (data) => {//success
                        this.setState({ classData: data});
                    }, () => {//fail
                        this.openNotificationWithIcon("error", "Server Failure", "Failed to get class data. Please close the updater and try again.");
                        console.log('failed to get default class data');
                    });
                
            }); //login
    }

    /**
    * Submit the update to class attendance
    */
    handleSubmit = (e) => {
        e.preventDefault();

        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                this.setState({ loading: true });
                // this allows attendance to be updated all at once or individually
                if (typeof this.props.multipleData !== 'undefined' && this.props.multipleData.length > 1 && typeof this.props.updateFields === 'undefined') {
                                                                                                            // to ensure not click on one student
                    //preformat data for backend
                    var multiUpdateData = this.props.multipleData.map((row) => {
                        return  row = {
                            StudentId: row.StudentId,
                            ClassId: this.props.updatingClassId,
                            GradesID: row.GradeId,
                        }
                    });

                    var formObj = {
                        MultiEnrollmentInfo: multiUpdateData,
                        UpdatedAttendance: values.selectUpdateAttendance
                    }
                
                    this.ajaxCall('POST', '/api/classes/updateMultipleAttendance/',
                        formObj, (data) => {//success
                            
                            this.openNotificationWithIcon('success', 'Updated Attendance', 'Attendance has been updated for the student!')
                            this.props.updateEvent();
                        }, () => {//fail
                            this.openNotificationWithIcon('error', 'Failed To Update or Failed to Send Email', 'Connection to server may have been lost!')
                        });
                }
                else {
                    var formObj = {
                        StudentId: this.props.updateFields.StudentId,
                        ClassId: this.props.updatingClassId,
                        GradesID: this.props.updateFields.GradeId,
                        UpdatedAttendance: values.selectUpdateAttendance
                    }
                    this.setState({ loading: true });

                    this.ajaxCall('POST', '/api/classes/updateAttendance/',
                        formObj, (data) => {//success
                            console.log(typeof data);
                            this.openNotificationWithIcon('success', 'Updated Attendance', 'Attendance has been updated for the student!')
                            this.props.updateEvent();
                        }, () => {//fail
                            this.openNotificationWithIcon('error', 'Failed To Update or Failed to Send Email', 'Connection to server may have been lost!')
                        });
                }
                this.setState({ loading: false });
            }
        });
    }

    /**
     * Used for custom ajax calls
     * @param {any} type
     * @param {any} url
     * @param {any} data
     * @param {any} done
     * @param {any} fail
     */
    ajaxCall(type, url, data, done, fail) {
        $.ajax({
            type: type,
            url: `${config.serverUrl}` + url,
            data: data
        })
            .done((data) => {
                done(data);
            })
            .fail((jqXHR, textStatus, errorThrown) => {
                fail();
            });
    }

    /**
    * Opend Notification window
    */
    openNotificationWithIcon = (type, title, body) => {
        notification[type]({
            message: title,
            description: body,
        });
    };

    handleSelectValidation = (_, selection) => {
        var valid = false;
        // if hybrid either can be chosen, other wise it must match offering
        if (this.props.classMode === 'Hybrid') {
            valid = true;
        } else if (selection !== this.props.classMode) {
            valid = false;
        } else if (selection === this.props.classMode) {
            valid = true;
        } else { // shouldn't ever reach this, but just for safety.
            valid = false;
        }
        
        return valid;
    }

    /**
     * Render Functino
     */
    render() {
        const { getFieldDecorator } = this.props.form;

        const formItemLayout = {
            labelCol: {
                xs: { span: 26 },
                sm: { span: 8 },
            },
            wrapperCol: {
                xs: { span: 26 },
                sm: { span: 14 },
            },
        };
        const tailFormItemLayout = {
            wrapperCol: {
                xs: {
                    span: 24,
                    offset: 0,
                },
                sm: {
                    span: 14,
                    offset: 6,
                },
            },
        };

        //const dateFormat = 'MM-DD-YYYY';

        return (
            <div>
                {this.state.login ?
                    <Spin spinning={this.state.loading}>
                        <Form onSubmit={this.handleSubmit}>
                            <FormItem {...formItemLayout}
                                label="Update attendance"
                                validate>
                                {getFieldDecorator('selectUpdateAttendance', {
                                    initalValue: this.props.classMode,
                                    rules: [{ required: true, message: 'Please select their new attendance!' },
                                    {validator: this.handleSelectValidation, message: "Ensure selection is the same as the class offering"}],
                                })(
                                    <div>
                                        <Select title="Select Mode"  style={{ width: 120 }} onChange={ 
                                                                (e) => { 
                                                                console.log(e); 
                                                                this.formVariables.selectUpdateAttendance = e; 
                                                                //this.setState({ selectUpdateAttendance: e}); 
                                                                this.props.form.setFieldsValue({selectUpdateAttendance: e}) }
                                                                }>
                                            <Option value="Online">Online</Option>
                                            <Option value="In Person">In Person</Option>
                                        </Select>
                                        <br/>Note: only do this if attendance doesn't match class mode offering excluding hybrid classes
                                    </div>
                                    
                                    )}
                            </FormItem>

                            <FormItem {...tailFormItemLayout}>
                                <Button type="default"  onClick={() => { this.props.updateEvent(); }} >Cancel</Button>
                                <Button  type="primary" style={{ margin: 5 }} size="large" onClick={(e) => { this.handleSubmit(e) }}>Submit</Button>
                            </FormItem>
                        </Form>
                    </Spin>
                    : <Redirect to="/login" replace />
                }
            </div>
        );
    }
}

const WrappedUpdateEnrollmentModalForm = Form.create()(UpdateEnrollmentModalForm);

export default WrappedUpdateEnrollmentModalForm;


// WEBPACK FOOTER //
// ./src/Admin/UpdateEnrollmentModalForm.js